import BaseService from './BaseService';
import config from 'common/config/config';

export default class HCNService extends BaseService {
  timeout = 12000;

  getHeader() {
    /** Override header because this service doesnt handle x-nonce */
    return {};
  }

  getContext() {
    return {
      authServiceToken:
        this.store.getState().general.auth.accessToken || undefined,
    };
  }

  getBaseUrl() {
    return config.host.hcn;
  }

  handleSuccess(fetchConfig, res) {
    const result = res.data ? res.data : res;
    return result;
  }
}
